//通用跳转组件
// getProductGlobal：产品分析
// getCompanyGlobal：公司分析
// getProductGlobal：中标人分析
// getProductGlobal：采购人分析
// getProductGlobal：产品分析

export default {


  getProductGlobal(obj,that){
    console.log('console.log(this)',this)
    let category_name = obj.product_category_name
    let category_id = obj.product_category_id
    let model_name = obj.product_model_name
    let model_id = obj.product_model_id
    let company_name = obj.company_name
    let company_id = obj.company_id
    let province = obj.province
    let industry = obj.industry
    let start_time = obj.start_time
    let end_time = obj.end_time
    let pathQuery ={
      t: Date.now(),
      product_category_name: obj.product_category_name,
      product_category_id: obj.product_category_id,
      product_model_name: obj.product_model_name,
      product_model_id: obj.product_model_id,
      company_name: obj.company_name,
      company_id: obj.company_id,
      province: obj.province,
      industry: obj.industry,
      start_time: obj.start_time,
      end_time: obj.end_time,
      type: obj.type
    }
    let noSearch = !category_name && !category_id && !model_name && !model_id  && !company_name  && !company_id  &&  province == '全国' && industry == '全部行业' && start_time && end_time
    // 选了 行业
    let industryChose = !category_name && !category_id && !model_name && !model_id  && !company_name  && !company_id  &&  province == '全国' && industry != '全部行业'
    // *选了 行业 产品
    let industryProduct = category_name && category_id &&!model_name && !model_id  && !company_name  && !company_id  &&  province == '全国' && industry != '全部行业'
    // *选了 行业 公司
    let industryCompany = !category_name && !category_id && !model_name && !model_id   &&  company_name  && company_id  &&  province == '全国' && industry != '全部行业'
    // *选了 行业 公司
    let industryProvince = !category_name && !category_id && !model_name && !model_id   &&  !company_name  && !company_id  &&  province != '全国' && industry != '全部行业'
    // *选了 行业 产品 公司
    let industryProductCompany =category_name && category_id &&!model_name && !model_id  && company_name  && company_id  &&  province == '全国' && industry != '全部行业'
    // *选了 行业 产品 省份
    let industryProductProvince = category_name && category_id &&!model_name && !model_id  && !company_name  && !company_id  &&  province != '全国' && industry != '全部行业'
    // *选了 行业 公司 省份
    let industryCompanyProvince = !category_name && !category_id && !model_name && !model_id  && company_name  && company_id  &&  province != '全国' && industry != '全部行业'
    // *选了 行业 产品 公司 省份
    let industryProductCompanyProvince = category_name && category_id &&!model_name && !model_id  && company_name  && company_id  &&  province != '全国' && industry != '全部行业'
    // *选了 产品
    let productChose = category_name && category_id &&!model_name && !model_id  && !company_name  && !company_id  &&  province == '全国' && industry == '全部行业'
    // *选了 产品 公司
    let productCompany = category_name && category_id &&!model_name && !model_id  && company_name  && company_id  &&  province == '全国' && industry == '全部行业'
    // *选了 产品 省份
    let productProvince = category_name && category_id &&!model_name && !model_id  && !company_name  && !company_id  &&  province != '全国' && industry == '全部行业'
    // *选了 产品 公司 省份
    let productCompanyProvince = category_name && category_id &&!model_name && !model_id  && company_name  && company_id  &&  province != '全国' && industry == '全部行业'
    // *选了 产品 公司 省份 型号
    let productCompanyProvinceModle = category_name && category_id && company_name  && company_id  && model_name && model_id &&  province != '全国' && industry == '全部行业'
    // *选了 产品 公司 行业 型号
    let productCompanyIndustryModle = category_name && category_id && company_name  && company_id  && model_name && model_id &&  province == '全国' && industry != '全部行业'
    // *选了 产品 公司 行业 型号 省份
    let productCompanyIndustryProvinceModle = category_name && category_id && company_name  && company_id  && model_name && model_id &&  province != '全国' && industry != '全部行业'
    // *选了型号
    let modelChose = model_name && model_id  &&  province == '全国' && industry == '全部行业'
    // 选了 省份
    let provinceChose = !category_name && !category_id && !model_name && !model_id   && !company_name  && !company_id  &&  province != '全国' && industry == '全部行业'
    // 选了 省份 公司
    let provinceCompany = !category_name && !category_id && !model_name && !model_id  && company_name  && company_id  &&  province != '全国' && industry == '全部行业'
    // 选了 公司
    let companyChose = !category_name && !category_id && !model_name && !model_id  && company_name  && company_id  &&  province == '全国' && industry == '全部行业'
    // 跳转位置
    // 只有时间
    if (noSearch) {that.$router.push({path: "/productResult", query: pathQuery})}
    // *选了 行业
    else if (industryChose) {that.$router.push({path: "/IndustryNext", query: pathQuery})}
    // *选了 行业 产品
    else if (industryProduct) {that.$router.push({path: "/IndustryCategoryNext", query: pathQuery})}
    // *选了 行业 公司
    else if (industryCompany) {that.$router.push({path: "/IndustryCompanyNext", query: pathQuery})}
    // *选了 行业 省份
    else if (industryProvince) {that.$router.push({path: "/IndustryProvinceNext", query: pathQuery})}
    // *选了 行业 产品 公司
    else if (industryProductCompany) {that.$router.push({path: "/IndustryCategoryCompanyNext", query: pathQuery})}
    // *选了 行业 产品 省份
    else if (industryProductProvince) {that.$router.push({path: "/IndustryCategoryProvinceNext", query: pathQuery})}
    // *选了 行业 公司 省份
    else if (industryCompanyProvince) {that.$router.push({path: "/IndustryProvinceCompanyNext", query: pathQuery})}
    // *选了 行业 产品 公司 省份
    else if (industryProductCompanyProvince) {that.$router.push({path: "/product/detailTypeSecond", query: pathQuery})}
    // *选了 产品
    else if (productChose) {that.$router.push({path: "/CategoryNext", query: pathQuery})}
    // *选了 产品 公司
    else if (productCompany) {that.$router.push({path: "/CategoryCompanyNext", query: pathQuery})}
    // *选了 产品 省份
    else if (productProvince) {that.$router.push({path: "/CategoryProvinceNext", query: pathQuery})}
    // *选了 产品 公司 省份
    else if (productCompanyProvince) {that.$router.push({path: "/CategoryCompanyProvinceNext", query: pathQuery})}
    // *选了 产品 公司 省份 型号
    else if (productCompanyProvinceModle) {that.$router.push({path: "/product/detailTypeThird", query: pathQuery})}
    // *选了 产品 公司 行业 型号
    else if (productCompanyIndustryModle) {that.$router.push({path: "/product/detailTypeThird", query: pathQuery})}
    // *选了 产品 公司 行业 型号 省份
    else if (productCompanyIndustryProvinceModle) {that.$router.push({path: "/product/detailTypeThird", query: pathQuery})}
    // *选了型号
    else if (modelChose) {that.$router.push({path: "/product/detailTypeThird", query: pathQuery})}
    // 选了 省份
    else if (provinceChose) {that.$router.push({path: "/ProvinceNext", query: pathQuery})}
    // 选了 省份 公司
    else if (provinceCompany) {that.$router.push({path: "/CompanyProvinceNext", query: pathQuery})}
    // 选了 公司
    else if (companyChose) {that.$router.push({path: "/companyResult", query: pathQuery})}

  },
  getCompanyGlobal(obj){
    return {
      company_id: obj.company_id,
      company_name: obj.company_name,
      product_category_id: obj.product_category_id,
      product_category_name: obj.product_category_name,
      product_model_name: obj.product_model_name,
      product_model_id: obj.product_model_id,
      product_attrib_id: obj.product_attrib_id,
      product_attrib_name: obj.product_attrib_name,
      province: obj.province,
      industry: obj.industry,
      start_time: obj.start_time,
      end_time: obj.end_time
    }
  }
}

